import(/* webpackMode: "eager" */ "/personal-project/app/globals.css");
import(/* webpackMode: "eager" */ "/personal-project/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/personal-project/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/personal-project/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/personal-project/components/ui/tooltip.tsx")